import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import history from '../history';

// import matchPropTypes from "./matchPropTypes";

/**
 * If we have a logged-in user, display the component, otherwise redirect to login page.
 */
const PrivateRoute = ({ component: Component, user, userPermissions, ...rest }) => {


  let targetUrl = history.location.pathname;
  let fullTargetUrl = history.location.pathname;
  let hasPermission = false;
  let pagePermission = [];

  let checkClientUserType = null;

  if (targetUrl.split("/")[1] !== "webadmin") {
    checkClientUserType =
      user && user.users3.userRoles.userType
        ? user.users3.userRoles.userType
        : null;
    let hasDefaultAccess =
      targetUrl === "/error404" ||
      targetUrl.split("/")[1] === "user-profile" ||
      targetUrl.split("/")[1] === "app-config" ||
      targetUrl.split("/")[1] === "apply-leaves" ||
      targetUrl.split("/")[1] === "non-billable-soap" ||
      targetUrl.split("/")[1] === "soap" ||
      targetUrl.split("/")[1] === "session-behaviorblossoms" ||
      targetUrl.split("/")[1] === "session-notes-data-collection" ||
      targetUrl.split("/")[1] === "session-notes-early-intervention" ||
      targetUrl.split("/")[1] === "session-notes-delaware-ei-ebs" ||
      targetUrl.split("/")[1] === "session-notes-ifsp-developmenttime-ebs" ||
      targetUrl.split("/")[1] === "session-cbg" ||
      targetUrl.split("/")[1] === "session-aip" ||
      targetUrl.split("/")[1] === "session-ne-aba" ||
      targetUrl.split("/")[1] === "session-pbs" ||
      targetUrl.split("/")[1] === "session-art" ||
      targetUrl.split("/")[1] === "session-bt-bestaba" ||
      targetUrl.split("/")[1] === "session-bcba-bestaba" ||
      targetUrl.split("/")[1] === "session-psychological-swan" ||
      targetUrl.split("/")[1] === "session-note-rbt-abaor" ||
      targetUrl.split("/")[1] === "session-note-bcba-abaor" ||
      targetUrl.split("/")[1] === "session-note-hyperion" ||
      targetUrl.split("/")[1] === "session-supervision-note-helpinghands" ||
      targetUrl.split("/")[1] === "session-psycheval-note-futures" ||
      targetUrl.split("/")[1] === "session-slpeval-note-futures" ||
      targetUrl.split("/")[1] === "session-note-assessment-soar" ||
      targetUrl.split("/")[1] === "session-note-directtherapy-soar" ||
      targetUrl.split("/")[1] === "session-note-bcbasupervision-soar" ||
      targetUrl.split("/")[1] === "session-note-familytreatment-soar" ||
      targetUrl.split("/")[1] === "session-note-diagnosticevaluation-soar" ||
      targetUrl.split("/")[1] === "session-notes-rbt-tfaba" ||
      targetUrl.split("/")[1] === "session-notes-bcba-tfaba" ||
      targetUrl.split("/")[1] === "session-notes-bt-default" ||
      targetUrl.split("/")[1] === "session-notes-bcba-default" ||
      targetUrl.split("/")[1] === "session-notes-illinois-evaluation-ebs" ||
      targetUrl.split("/")[1] === "session-notes-illinois-ebs" ||
      targetUrl.split("/")[1] === "custom-session-notes" || // JWM TODO: Is this right?
      targetUrl.split("/")[1] === "custom-session-nonbillable-soap" ||
      targetUrl.split("/")[1] === "progress-note-one" ||
      targetUrl.split("/")[1] === "video-soap" ||
      targetUrl.split("/")[1] === "soap-encounter" ||
      targetUrl.split("/")[1] === "session-encounter-behaviorblossoms" ||
      targetUrl.split("/")[1] === "session-encounter-data-collection" ||
      targetUrl.split("/")[1] === "session-encounter-early-intervention" ||
      targetUrl.split("/")[1] === "session-encounter-delaware-ei-ebs" ||
      targetUrl.split("/")[1] === "session-encounter-ifsp-developmenttime-ebs" ||
      targetUrl.split("/")[1] === "session-encounter-cbg" ||
      targetUrl.split("/")[1] === "session-encounter-aip" ||
      targetUrl.split("/")[1] === "session-encounter-ne-aba" ||
      targetUrl.split("/")[1] === "session-encounter-pbs" ||
      targetUrl.split("/")[1] === "session-encounter-art" ||
      targetUrl.split("/")[1] === "session-encounter-bt-bestaba" ||
      targetUrl.split("/")[1] === "session-encounter-bcba-bestaba" ||
      targetUrl.split("/")[1] === "session-encounter-psychological-swan" ||
      targetUrl.split("/")[1] === "session-encounter-rbt-abaor" ||
      targetUrl.split("/")[1] === "session-encounter-bcba-abaor" ||
      targetUrl.split("/")[1] === "session-encounter-hyperion" ||
      targetUrl.split("/")[1] === "session-encounter-assessment-soar" ||
      targetUrl.split("/")[1] === "session-encounter-directtherapy-soar" ||
      targetUrl.split("/")[1] === "session-encounter-bcbasupervision-soar" ||
      targetUrl.split("/")[1] === "session-encounter-familytreatment-soar" ||
      targetUrl.split("/")[1] === "session-encounter-diagnosticevaluation-soar" ||
      targetUrl.split("/")[1] === "session-encounter-rbt-tfaba" ||
      targetUrl.split("/")[1] === "session-encounter-bcba-tfaba" ||
      targetUrl.split("/")[1] === "session-encounter-bt-default" ||
      targetUrl.split("/")[1] === "session-encounter-bcba-default" ||
      targetUrl.split("/")[1] === "session-encounter-illinois-evaluation-ebs" ||
      targetUrl.split("/")[1] === "session-encounter-illinois-ebs" ||
      targetUrl.split("/")[1] === "session-encounter-custom-session-notes" || // JWM TODO: Is this right?
      targetUrl.split("/")[1] === "session-supervision-encounter-helpinghands" ||
      targetUrl.split("/")[1] === "session-psycheval-encounter-futures" ||
      targetUrl.split("/")[1] === "session-slpeval-encounter-futures" ||
      targetUrl.split("/")[1] === "progress-encounter-one" ||
      targetUrl.split("/")[1] === "non-billable-soap-encounter" ||
      (user &&
        (user.users3.userRoles.userType === "ADMIN" ||
          user.users3.userRoles.userType === "PATIENT"))
        ? true
        : false; // For Role

    targetUrl = "/" + targetUrl.split("/")[1];
    fullTargetUrl =
      "/" + fullTargetUrl.split("/")[1] + "/" + fullTargetUrl.split("/")[2];

    if (!hasDefaultAccess && userPermissions) {
      pagePermission = userPermissions
        ? userPermissions.modulePermissions.filter((obj) =>
            obj.navigationLink === targetUrl ? true : false
          )
        : false;

      if (pagePermission && pagePermission.length > 0) {
        hasPermission = pagePermission ? pagePermission[0].permission : false;
      }

      if (!hasPermission) {
        pagePermission = userPermissions
          ? userPermissions.modulePermissions.filter((obj) =>
              obj.navigationLink === fullTargetUrl ? true : false
            )
          : false;

        if (pagePermission && pagePermission.length > 0) {
          hasPermission = pagePermission ? pagePermission[0].permission : false;
        }
      }

      if (!hasPermission) {
        pagePermission = userPermissions
          ? userPermissions.screenPermissions.filter((obj) =>
              obj.navigationLink === targetUrl ? true : false
            )
          : false;

        if (pagePermission && pagePermission.length > 0) {
          hasPermission = pagePermission ? pagePermission[0].permission : false;
        }
      }

      if (!hasPermission) {
        pagePermission = userPermissions
          ? userPermissions.screenPermissions.filter((obj) =>
              obj.navigationLink === fullTargetUrl ? true : false
            )
          : false;

        if (pagePermission && pagePermission.length > 0) {
          hasPermission = pagePermission ? pagePermission[0].permission : false;
        }
      }

      if (!hasPermission && targetUrl === "/reports") {
        hasPermission = true;
      }

      if (!hasPermission && targetUrl === "/payer") {
        hasPermission = userPermissions
          ? userPermissions.actionPermissions.filter(
              (obj) =>
                obj.actionKey === "PAYER_LIST_ADD" ||
                obj.actionKey === "PAYER_LIST_UPDATE"
            )[0].permission
          : false;
      }

      if (!hasPermission && targetUrl === "/client") {
        hasPermission = userPermissions
          ? userPermissions.actionPermissions.filter(
              (obj) => obj.actionKey === "CLIENT_PROFILE_UPDATE"
            )[0].permission
          : false;
      }
    } else {
      hasPermission = hasDefaultAccess;
    }
  } else {
    hasPermission = true;
  }

  if (checkClientUserType === 'CLIENT') {
    return (
      <Route
        {...rest}
        render={(props) =>
          user
            ? <Component user={user} {...props} />
            : <Redirect to={{ pathname: '/' }} />}
      />
    );
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        hasPermission ? user
          ? <Component user={user} {...props} />
          : <Redirect to={{ pathname: '/' }} />
          : <Redirect to={{ pathname: '/error404' }} />}
    />
  );
};

//  PrivateRoute.propTypes = matchPropTypes;

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/routers/PrivateRoute.js